import React from "react";

export function Logo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // viewBox="0 0 143.62 36"
      height="90%"
      viewBox="0 -4 150 40"
    >
      <rect
        stroke="currentcolor"
        strokeWidth="2.5px"
        fill="none"
        x="108.87"
        y="1.25"
        width="33.5"
        height="33.5"
        rx="4"
      />
      <path
        fill="currentcolor"
        d="M112.62,20.05c1.68,1.86,6.62,11,8.88,11s11.4-17.34,12.78-19.09c.27-.33,1.64-2.16,2.51-3.1A24.54,24.54,0,0,1,139,6.58c1-.38-4.29-1.2-5.59-1.2s-1.71.15-3.44,3.45c-1,1.59-7.16,14.05-8.47,14.05s-3.3-4.17-3.3-7.45S113.23,16.69,112.62,20.05Z"
      />
      <path
        fill="currentcolor"
        d="M3.17,11.58A14.7,14.7,0,0,1,0,10.72V10.1H12v.57a5.92,5.92,0,0,1-1.58.55,20.19,20.19,0,0,1-2.12.41l6,18.29,6.77-18.34a16.13,16.13,0,0,1-3.55-.81V10.1h9.6v.57a11.86,11.86,0,0,1-3.17.91L15.41,34H11.09Z"
      />
      <path
        fill="currentcolor"
        d="M29.9,33.38a32.73,32.73,0,0,1,3.8-1V11.92a23.85,23.85,0,0,1-3.32-.86v-.44L39,9.76V32.42a27.46,27.46,0,0,1,3.84,1V34h-13Zm3.92-26.5A2.81,2.81,0,0,1,33,4.77a2.89,2.89,0,0,1,.84-2.14A2.94,2.94,0,0,1,36,1.79a3,3,0,0,1,2.21.84,2.87,2.87,0,0,1,.86,2.14,2.79,2.79,0,0,1-.86,2.11A3.11,3.11,0,0,1,36,7.7,3,3,0,0,1,33.82,6.88Z"
      />
      <path
        fill="currentcolor"
        d="M56.83,33.35a7.4,7.4,0,0,1-3.17-3,23.15,23.15,0,0,1-1,3.6H49.1V2.27a22.69,22.69,0,0,1-3.31-.86V1L54.43.11V12.74a9.6,9.6,0,0,1,3.94-2.45,14.33,14.33,0,0,1,4.22-.63A11.13,11.13,0,0,1,68.11,11a9.59,9.59,0,0,1,3.84,4,13.69,13.69,0,0,1,1.39,6.41q0,6.63-3,9.82t-8.52,3.19A10.56,10.56,0,0,1,56.83,33.35Zm9.58-3.77a16.17,16.17,0,0,0,1.65-7.87c0-3.36-.56-5.89-1.7-7.58s-3-2.55-5.5-2.55a7.11,7.11,0,0,0-3.6,1A9.66,9.66,0,0,0,54.43,15v10.8a6.81,6.81,0,0,0,1.78,4.78,6.25,6.25,0,0,0,4.85,1.94A5.66,5.66,0,0,0,66.41,29.58Z"
      />
      <path
        fill="currentcolor"
        d="M101,22.24H82.66A12.53,12.53,0,0,0,85,29.7a7.58,7.58,0,0,0,6.48,3A14.46,14.46,0,0,0,95.57,32a12.26,12.26,0,0,0,3.74-1.8l.53,1.39a12.83,12.83,0,0,1-4,2,17.73,17.73,0,0,1-5.57.84,14.47,14.47,0,0,1-6.86-1.54,10.82,10.82,0,0,1-4.52-4.34,13.06,13.06,0,0,1-1.58-6.5q0-6,3.33-9.2t9.24-3.24a11.73,11.73,0,0,1,6.24,1.54,9.38,9.38,0,0,1,3.7,4.1A13.44,13.44,0,0,1,101,21Zm-4.7-1.92a13.44,13.44,0,0,0-.63-4,7.48,7.48,0,0,0-2-3.36,5.15,5.15,0,0,0-3.72-1.35,5.9,5.9,0,0,0-5.06,2.48,12.28,12.28,0,0,0-2.14,6.26Z"
      />
    </svg>
  );
}
